module.exports = __webpack_public_path__ + "static/media/Government-Building.79628d3b.jpg";